import { Component } from '@angular/core';

@Component({
  selector: 'app-call-offer-non-abonne',
  templateUrl: './call-offer-non-abonne.component.html',
  styleUrls: ['./call-offer-non-abonne.component.css']
})
export class CallOfferNonAbonneComponent {

}
